import React from 'react'
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import IconButton from '@mui/material/IconButton';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import * as yup from "yup";
import { useFormik } from "formik";
import FormHelperText from '@mui/material/FormHelperText';

const UpdateInvoice = (props) => {
  const {is_invoice_modal_open,handleInvoiceModal,selected_invoice} = props;
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  const handleAccountCloseModalChange = () => {
    formik.resetForm();
    handleInvoiceModal(false);
  };

  const validationSchema = yup.object().shape({
    invoice_no : yup.string().required('Invoice no is required.'),
    invoice_date : yup.string().required('Invoice Date is required.'),
    job_no : yup.string().required('Job no is required.'),
    ref_no : yup.string().required('Ref no is required.'),
    job_type : yup.string().required('Job Type is required.'),
    description : yup.string().required('Description is required.'),
    status : yup.string().required('Status is required.')
  });

  const onSubmit = async (values) => {
    // login(values);
    console.log(values);
  };

  const formik = useFormik({
    enableReinitialize : true,
    initialValues : selected_invoice !== null ? selected_invoice : {
      invoice_no : "",
      invoice_date : "",
      job_no : "",
      ref_no : "",
      job_type : "",
      description : "",
      status : ""
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
        onSubmit(values);
    },
})

  return (
    <Dialog
        fullScreen={fullScreen}
        open={is_invoice_modal_open}
        onClose={handleAccountCloseModalChange}
        aria-labelledby="responsive-dialog-title"
        component='form'
        onSubmit={formik.handleSubmit}
      >
        <DialogTitle id="responsive-dialog-title" sx={{
          display:'flex',
          justifyContent : 'space-between',
          alignItems : 'center'
        }}>
          Update Invoice
          <IconButton size='medium' onClick={handleAccountCloseModalChange}>
            <CloseOutlinedIcon/>
          </IconButton>
        </DialogTitle>
        <DialogContent 
          sx={{
            '& .MuiTextField-root,.MuiFormControl-root': {
              my:1.2,
              width: {md:'30ch',xs:'100%'},
              fontSize:'14px'
            },
            '& .MuiStack-root > .MuiFormControl-root:first-of-type':{
              marginRight :{md:1,xs:0}
            },
            '& .MuiStack-root > .MuiFormControl-root:last-child':{
              marginLeft : {md:1,xs:0}
            },
            '& .MuiFormHelperText-root' : {
              ml:0
            }
        }}
        >
          <Stack sx={{
            display : 'flex',
            flexDirection : {md:'row',xs:'column'},
            justifyContent : 'space-between'
          }}>
            <TextField
              disabled
              label="Invoice No" 
              variant="outlined" 
              size='small' 
              fullWidth
              name="invoice_no"
              value={formik.values.invoice_no}
              onChange={formik.handleChange("invoice_no")}
              onBlur={formik.handleBlur("invoice_no")}
              error={
                  formik.touched.invoice_no && Boolean(formik.errors.invoice_no)
              }
              helperText={formik.touched.invoice_no && formik.errors.invoice_no}
              />
            <TextField
              disabled
              label="Invoice Date" 
              variant="outlined" 
              size='small' 
              fullWidth
              name="invoice_date"
              value={formik.values.invoice_date}
              onChange={formik.handleChange("invoice_date")}
              onBlur={formik.handleBlur("invoice_date")}
              error={
                  formik.touched.invoice_date && Boolean(formik.errors.invoice_date)
              }
              helperText={formik.touched.invoice_date && formik.errors.invoice_date}
              />
          </Stack>
          <Stack sx={{
            display : 'flex',
            flexDirection : {md:'row',xs:'column'},
            justifyContent : 'space-between'
          }}>
            <TextField
              disabled
              label="Job No" 
              variant="outlined" 
              size='small' 
              fullWidth
              name="job_no"
              value={formik.values.job_no}
              onChange={formik.handleChange("job_no")}
              onBlur={formik.handleBlur("job_no")}
              error={
                  formik.touched.job_no && Boolean(formik.errors.job_no)
              }
              helperText={formik.touched.job_no && formik.errors.job_no}
              />
            <TextField
              disabled
              label="Ref #" 
              variant="outlined" 
              size='small' 
              fullWidth
              name="ref_no"
              value={formik.values.ref_no}
              onChange={formik.handleChange("ref_no")}
              onBlur={formik.handleBlur("ref_no")}
              error={
                  formik.touched.ref_no && Boolean(formik.errors.ref_no)
              }
              helperText={formik.touched.ref_no && formik.errors.ref_no}
              />
          </Stack>
          <Stack sx={{
            display : 'flex',
            flexDirection : {md:'row',xs:'column'},
            justifyContent : 'space-between'
          }}>
            <TextField
              disabled
              label="Job Type" 
              variant="outlined" 
              size='small' 
              fullWidth
              name="job_type"
              value={formik.values.job_type}
              onChange={formik.handleChange("job_type")}
              onBlur={formik.handleBlur("job_type")}
              error={
                  formik.touched.job_type && Boolean(formik.errors.job_type)
              }
              helperText={formik.touched.job_type && formik.errors.job_type}
              />
            <FormControl size="small"  error={formik.touched.status && Boolean(formik.errors.status)}>
              <InputLabel id="demo-select-small-label">Select Status</InputLabel>
              <Select
                labelId="demo-select-small-label"
                id="demo-select-small"
                value={formik.values.status}
                onChange={formik.handleChange("status")}
                onBlur={formik.handleBlur("status")}
                label="Select Status"
              >
                <MenuItem disabled value="">
                <p>Select a status</p>
                </MenuItem>
                <MenuItem value={'PAID'}>PAID</MenuItem>
                <MenuItem value={'UNPAID'}>UNPAID</MenuItem>
              </Select>
              <FormHelperText>{formik.touched.status && formik.errors.status}</FormHelperText>
            </FormControl>
          </Stack>
          <Stack sx={{
            '& .MuiTextField-root,.MuiFormControl-root': {
              my:1.2,
              width: {md:'100%'},
              fontSize:'14px',
            },
          }}>
            <TextField
              sx={{
                ml:"0!important"
              }}
              label="Description" 
              variant="outlined" 
              size='small' 
              fullWidth
              multiline
              minRows={2}
              maxRows={4}
              name="description"
              value={formik.values.description}
              onChange={formik.handleChange("description")}
              onBlur={formik.handleBlur("description")}
              error={
                  formik.touched.description && Boolean(formik.errors.description)
              }
              helperText={formik.touched.description && formik.errors.description}
            />
          </Stack>
          
        </DialogContent>
        <DialogActions sx={{
          padding : '8px 16px 24px 24px',
          '& .MuiButtonBase-root:last-child' : {
            marginLeft : '16px'
          }
        }}>
          <Button variant='outlined' color='error' onClick={handleAccountCloseModalChange}>
            Cancel
          </Button>
          <Button variant='contained' type='submit'>
            Update
          </Button>
        </DialogActions>
    </Dialog>
  )
}

export default UpdateInvoice;